import { render } from "./AudioElementOperate.vue?vue&type=template&id=cd57add4&scoped=true&ts=true"
import script from "./AudioElementOperate.vue?vue&type=script&lang=ts"
export * from "./AudioElementOperate.vue?vue&type=script&lang=ts"

import "./AudioElementOperate.vue?vue&type=style&index=0&id=cd57add4&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd57add4"]])

export default __exports__